<div class="sidebar-header">
    <div class="logo clearfix pb-0">
        <a (click)="redirecionar()" class="logo-text text-left">
            <div class="logo-img">
                <img [src]="logoHeader" class="imgLogo text" />
                <img [src]="logoHeaderReduzido" class="imgLogo mini" />
            </div>
        </a>
        <a class="nav-toggle d-none d-sm-none d-md-none d-lg-block novoLayout" id="sidebarToggle" href="javascript:;">
            <i class="centericon centericon-fixar_menu toggle-icon" data-toggle="expanded" (click)="event()"></i>
        </a>
        <a class="nav-close d-block d-md-block d-lg-none d-xl-none" id="sidebarClose" href="javascript:;">
            <i class="ft-x"></i>
        </a>
    </div>
</div>
<script type="text/javascript" src="./assets/js/customizer.js"></script>

<div class="sidebar-content">
    <div class="nav-container">
        <ul class="navigation novoLayout">
            <li *ngFor="let menuItem of menuSidebar" [ngClass]="[menuItem.class]"
                [routerLinkActive]="menuItem.submenu.length !== 0 ? '' : 'active'"
                [routerLinkActiveOptions]="{exact: true}" #menuItemElement>

                <a (click)="cleanFilterSessionStorage(); onMenuItemClick(menuItem)" [routerLink]="menuItem.class === '' ? [menuItem.path] : null"
                    *ngIf="!menuItem.isExternalLink && menuItem.show">
                    <i [ngClass]="[menuItem.icon]"></i>
                    <span class="menu-title">
                      {{ menuItem.title | translate }}
                      <span *ngIf="sidebarService.contemPreCadastros && menuItem.pointAttention"
                            class="notification-dot"
                            [ngClass]="sidebarService.contemPreCadastros ? 'active' : 'inactive'">
                      </span>
                      <span *ngIf="menuItem.newFeature && !menuItemElement.classList.contains('open')" class="notification-new-submenu">{{'NOVO_TAG'|translate}}</span>
                    </span>
                    <span *ngIf="menuItem.badge !== '' " [ngClass]="[menuItem.badgeClass]">{{menuItem.badge}}</span>
                </a>

                <a *ngIf="menuItem.isExternalLink && menuItem.show" [href]="[menuItem.path]" target="_blank" rel="noopener noreferrer">
                    <i [ngClass]="[menuItem.icon]"></i>
                    <span class="menu-title">{{menuItem.title | translate}}</span>
                    <span *ngIf="menuItem.badge !== '' " [ngClass]="[menuItem.badgeClass]">{{menuItem.badge}}</span>
                </a>

                <ul class="menu-content" *ngIf="menuItem.submenu.length > 0">
                    <li *ngFor="let menuSubItem of menuItem.submenu" [routerLinkActive]="menuSubItem.submenu.length > 0 ? '' : 'active'"
                        [ngClass]="[menuSubItem.class]">

                        <a [routerLink]="menuSubItem.submenu.length > 0 ? null : [menuSubItem.path]"
                           (click)="onMenuItemClick(menuSubItem)"
                           *ngIf="!menuSubItem.isExternalLink && menuSubItem.show">
                            <i [ngClass]="[menuSubItem.icon]"></i>
                            <span class="menu-title">{{menuSubItem.title | translate}}</span>
                            <span *ngIf="menuSubItem.newFeature && menuItemElement.classList.contains('open')" class="notification-new-submenu notification-new-submenu-item">{{'NOVO_TAG'|translate}}</span>
                            <span *ngIf="menuSubItem.badge !== '' " [ngClass]="[menuSubItem.badgeClass]">{{menuSubItem.badge}}</span>
                        </a>

                        <a *ngIf="menuSubItem.isExternalLink && menuSubItem.show" [href]="[menuSubItem.path]">
                            <i [ngClass]="[menuSubItem.icon]"></i>
                            <span class="menu-title">{{menuSubItem.title | translate}}</span>
                            <span *ngIf="menuSubItem.badge !== '' " [ngClass]="[menuSubItem.badgeClass]">{{menuSubItem.badge}}</span>
                        </a>

                        <ul class="menu-content" *ngIf="menuSubItem.submenu.length > 0">
                            <li *ngFor="let menuSubsubItem of menuSubItem.submenu" routerLinkActive="active"
                                [routerLinkActiveOptions]="{exact: true}" [ngClass]="[menuSubsubItem.class]">

                                <a [routerLink]="[menuSubsubItem.path]" (click)="onMenuItemClick(menuSubsubItem)" *ngIf="!menuSubsubItem.isExternalLink && menuSubsubItem.show">
                                    <i [ngClass]="[menuSubsubItem.icon]"></i>
                                    <span class="menu-title">{{menuSubsubItem.title | translate}}</span>
                                    <span *ngIf="menuSubsubItem.badge !== '' " [ngClass]="[menuSubsubItem.badgeClass]">{{menuSubsubItem.badge}}</span>
                                </a>

                                <a *ngIf="menuSubsubItem.isExternalLink && menuSubsubItem.show" [href]="[menuSubsubItem.path]">
                                    <i [ngClass]="[menuSubsubItem.icon]"></i>
                                    <span class="menu-title">{{menuSubsubItem.title | translate}}</span>
                                    <span *ngIf="menuSubsubItem.badge !== '' " [ngClass]="[menuSubsubItem.badgeClass]">{{menuSubsubItem.badge}}</span>
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </li>
        </ul>
    </div>
</div>
